import { render, staticRenderFns } from "./CoverHome.vue?vue&type=template&id=d266f89a"
import script from "./CoverHome.vue?vue&type=script&lang=js"
export * from "./CoverHome.vue?vue&type=script&lang=js"
import style0 from "./CoverHome.vue?vue&type=style&index=0&id=d266f89a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports